import React, { Fragment, useMemo } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

import moment from "moment";
import { numberCommaString } from "helpers";
import classNames from "classnames";

import { ACTCODE_COMMENT_CONTENTS, ACTCODE_TITLE } from "constant/log";
import { COMMENT_CONTENTS, COMMENT_NICKNAME, COMMENT_USER_ID, TITLE } from "constant/search";
import { JAVASCRIPT_VOID } from "constant/config";

import Highlight from "components/Highlight";
import Nickname from "components/contents/Nickname";
import { ProfileImage } from "components/ImageHandle";
import PostLink from "components/boards/post/PostLink";
import PostHomePin from "components/boards/post/PostHomePin";
import PrintDate from "components/boards/common/PrintDate";
import NickNameBadge from "components/boards/post/feed/NickNameBadge";

const CatchInfo = ({ vod, inflowPath, page, pageType, showCatchInfo = true }) => {
	const { t } = useTranslation();

	// vod 정보 조회
	const { ucc = {}, count = {}, comment = null, copyright = null, reserve = null, like = null } = vod;
	const { cate = {} } = ucc;
	const { badge = {} } = vod;

	return (
		<Fragment>
            {/*모바일,pc 메인 > 세로형 캐치 리스트*/}
            {page==="main" && (
                    <div className="info_area">	
                    {/* 제목 영역 */}
                    <p className="tit" title={vod.title_name}>{vod.title_name}</p>
                        {/* 조회 수 노출 */}
                        {!reserve && (
                            <Fragment>
                                {count.read_cnt !==undefined && <span className={classNames(!isMobile ? "view" : "play")}>{numberCommaString(count.read_cnt)}</span>}
                            </Fragment>
                        )}
                    </div>
            )}
               
            {/*모바일 vod > 세로형 캐치 리스트*/}
            {page==="vod" && (
                <div className="catch-info">
                    {/* 제목 영역 */}
                    <p className="title">{vod.title_name}</p>
                    <div className="info">
                        {/* 조회 수 노출 */}	
                        {!reserve && (
                            <Fragment>
                                {count.read_cnt !==undefined && <span className="views"><em>{numberCommaString(count.read_cnt)}</em></span>}
                            </Fragment>
                        )}
                    </div>
                </div>
            )}

            {/*PC vod 그리드형 캐치 리스트*/}
            {page==="pc_vod" && (
                <div className="vod-info">
                    {/* 제목 영역 */}
                    <PostLink post={vod} inflowPaths={inflowPath} pageType={pageType}>
                        <p className="title">{vod.title_name}</p>
                    </PostLink>
					{showCatchInfo && <div className="info">
						{/* 뱃지 */}
						{badge && (global.bj_id !== vod.user_id) && ( // 작성한 사람이 본인이면 제외
							<NickNameBadge badge={badge} />
						)}
						{/* 닉네임 */}
						<Nickname item={vod} right="auto">
							<a href={JAVASCRIPT_VOID} className="nick">{vod.user_nick}</a>
						</Nickname>
						{/* 조회 수 노출 */}
						{!reserve && (
							<Fragment>
								{count.read_cnt !== undefined &&
									<span className="views"><em></em>{numberCommaString(count.read_cnt)}</span>}
							</Fragment>
						)}
						{/* 날짜 노출 */}
						<span className="date">
                            {vod.reg_date.split(" ")[0].replaceAll("-", ".")}
                        </span>
					</div>}
                </div>
            )}
		</Fragment>
	);
};

export default CatchInfo;
